import gql from 'graphql-tag';

export const LevelsetsDomainOrSmallSubsetSkillDataQuery = gql`
  query DomainOrSmallSubsetSkillDataQuery($programId: [String!]!) {
    DomainOrSmallSubsetSkillDataQuery(input: { program_id: $programId })
      @rest(
        path: "grpc/enterpriseskills/programskills/v1beta1/ProgramSkillsAPI/GetSkillsByProgram"
        type: "Skill"
        method: "POST"
      ) {
      skills
    }
  }
`;
